import React from 'react';

import { StoreListing } from '@portals/api/partners';
import { DetailsPanel } from '@portals/core';

import {
  canArchiveStoreListing,
  canDeleteStoreListing,
  canEditStoreListing,
  canPreviewStoreListing,
  canPublishStoreListing,
} from '../../store-listings-page.utils';

interface DetailsPanelActionsProps {
  storeListing: StoreListing;
  onArchive: (storeListing: StoreListing) => void;
  onDelete: (storeListing: StoreListing) => void;
  onEdit: (storeListing: StoreListing) => void;
  onPublish: (storeListing: StoreListing) => void;
}

export function DetailsPanelActions({
  storeListing,
  onEdit,
  onPublish,
  onDelete,
  onArchive,
}: DetailsPanelActionsProps) {
  return (
    <DetailsPanel.Actions>
      {canPreviewStoreListing(storeListing) && (
        <DetailsPanel.ActionButton onClick={() => onEdit(storeListing)}>
          Preview
        </DetailsPanel.ActionButton>
      )}

      {canPublishStoreListing(storeListing) && (
        <DetailsPanel.ActionButton
          variant="filled"
          onClick={() => onPublish(storeListing)}
        >
          Publish
        </DetailsPanel.ActionButton>
      )}

      {canEditStoreListing(storeListing) && (
        <DetailsPanel.ActionButton
          data-testid="edit-store-listing-btn"
          onClick={() => onEdit(storeListing)}
        >
          Edit
        </DetailsPanel.ActionButton>
      )}

      {canArchiveStoreListing(storeListing) && (
        <DetailsPanel.ActionButton
          data-testid="archive-store-listing-btn"
          onClick={() => onArchive(storeListing)}
        >
          Archive
        </DetailsPanel.ActionButton>
      )}

      {canDeleteStoreListing(storeListing) && (
        <DetailsPanel.ActionButton
          data-testid="delete-store-listing-btn"
          onClick={() => onDelete(storeListing)}
        >
          Delete
        </DetailsPanel.ActionButton>
      )}
    </DetailsPanel.Actions>
  );
}
